import { lazy } from 'app/lazy'
import { ReactFlowProvider } from 'reactflow'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import ClientContext from 'features/common/ui/ClientContext'
import { Client } from 'features/common/utils/clientParameter'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { WorkflowsLoginPrompt } from './Prompts'
import { WorkflowErrorBoundary } from './WorkflowErrorBoundary'

const WorkflowEditorPage = lazy(() => import('./Routes/WorkflowEditorPage'))
const WorkflowCreatePage = lazy(() => import('./Routes/WorkflowCreatePage'))

const routes = [
  {
    path: 'workflows',
    element: <ClientContext client={Client.WorkflowsUI} />,
    children: [
      {
        path: 'create',
        exact: true,
        element: (
          <LazyLoad>
            <AuthenticatedRoute element={<WorkflowCreatePage />} prompt={<WorkflowsLoginPrompt />} />
          </LazyLoad>
        )
      },
      {
        path: ':workflowId',
        element: (
          <LazyLoad>
            <ReactFlowProvider>
              <AuthenticatedRoute
                element={
                  <WorkflowErrorBoundary>
                    <WorkflowEditorPage />
                  </WorkflowErrorBoundary>
                }
                prompt={<WorkflowsLoginPrompt />}
                allowGuestAccess
              />
            </ReactFlowProvider>
          </LazyLoad>
        )
      }
    ]
  }
]

export default routes
